import React, { useState } from 'react';
import { Card, Button, Typography, Space, Spin, Empty, message, Modal, Input } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { engagementAdminService } from '../../services/engagementAdmin.service';

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;

export const LotteryRegulationPage: React.FC = () => {
  const queryClient = useQueryClient();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [content, setContent] = useState('');

  const { data: regulation, isLoading } = useQuery({
    queryKey: ['admin', 'lottery-regulation'],
    queryFn: () => engagementAdminService.getRegulation(),
  });

  const publishMutation = useMutation({
    mutationFn: (c: string) => engagementAdminService.publishRegulation(c),
    onSuccess: () => {
      message.success('Regulamento publicado com sucesso');
      setEditModalOpen(false);
      queryClient.invalidateQueries({ queryKey: ['admin', 'lottery-regulation'] });
    },
    onError: (err: any) => message.error(err?.response?.data?.message || 'Erro ao publicar regulamento'),
  });

  const handleOpenEdit = () => {
    setContent(regulation?.content ?? '');
    setEditModalOpen(true);
  };

  return (
    <div style={{ padding: 24, maxWidth: 800 }}>
      <Space style={{ marginBottom: 16, width: '100%', justifyContent: 'space-between' }}>
        <Title level={3} style={{ margin: 0 }}>
          Regulamento dos Sorteios
        </Title>
        <Button type="primary" icon={<EditOutlined />} onClick={handleOpenEdit}>
          {regulation ? 'Publicar nova versão' : 'Publicar regulamento'}
        </Button>
      </Space>

      {isLoading ? (
        <Spin />
      ) : !regulation ? (
        <Empty description="Nenhum regulamento publicado ainda" />
      ) : (
        <Card>
          <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
            Versão publicada em: {new Date(regulation.publishedAt).toLocaleString('pt-BR')}
          </Text>
          <Paragraph style={{ whiteSpace: 'pre-wrap', maxHeight: '60vh', overflowY: 'auto' }}>
            {regulation.content}
          </Paragraph>
        </Card>
      )}

      <Modal
        title="Publicar novo regulamento"
        open={editModalOpen}
        onCancel={() => setEditModalOpen(false)}
        onOk={() => {
          if (!content.trim()) return message.error('O conteúdo não pode estar vazio');
          publishMutation.mutate(content.trim());
        }}
        confirmLoading={publishMutation.isPending}
        width={700}
      >
        <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
          Cada publicação cria uma nova versão. A versão mais recente será exibida aos participantes.
        </Text>
        <TextArea
          rows={14}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Insira o texto completo do regulamento..."
        />
      </Modal>
    </div>
  );
};

export default LotteryRegulationPage;
